
import React from 'react';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Building2Icon, UsersIcon, MapIcon, ChartBarIcon } from 'lucide-react';

export const StatCards: React.FC = () => {
  // Mock data - would be replaced with actual data from API
  const stats = [
    {
      title: 'Establecimientos',
      value: '125',
      change: '+5%',
      icon: Building2Icon,
      trend: 'up',
      description: 'Total registrados'
    },
    {
      title: 'Plazas',
      value: '3,420',
      change: '+3%',
      icon: UsersIcon,
      trend: 'up',
      description: 'Capacidad total'
    },
    {
      title: 'Tasa de Respuesta',
      value: '78%',
      change: '+12%',
      icon: ChartBarIcon,
      trend: 'up',
      description: 'Últimos 30 días'
    },
    {
      title: 'Regiones Activas',
      value: '8',
      change: '0%',
      icon: MapIcon,
      trend: 'neutral',
      description: 'Con establecimientos'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <Card key={index}>
          <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
            <CardTitle className="text-sm font-medium">
              {stat.title}
            </CardTitle>
            <div className="p-2 bg-primary/10 rounded-full">
              <stat.icon className="h-4 w-4 text-primary" />
            </div>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{stat.value}</div>
            <p className="text-xs text-muted-foreground">{stat.description}</p>
          </CardContent>
          <CardFooter className="pt-0">
            <p className={`text-xs ${
              stat.trend === 'up' ? 'text-green-500' : 
              stat.trend === 'down' ? 'text-red-500' : 
              'text-gray-500'
            }`}>
              {stat.change} desde el mes pasado
            </p>
          </CardFooter>
        </Card>
      ))}
    </div>
  );
};
